module.exports = __webpack_public_path__ + "img/toggle.332220e2.svg";